export  const validatePassword = (password: string, confirmPassword: string, setErrorMessage: any) => {
  if (password.length < 8) {
    setErrorMessage('La contraseña debe contener mínimo 8 caracteres');
  } else if (!/[A-Z]/.test(password)) {
    setErrorMessage('La contraseña debe contener al menos una letra mayúscula');
  } else if (!/[a-z]/.test(password)) {
    setErrorMessage('La contraseña debe contener al menos una letra minúscula');
  } else if (!/[^A-Za-z0-9]/.test(password)) {
    setErrorMessage('La contraseña debe contener al menos un símbolo');
  } else if (confirmPassword) {
    if (password !== confirmPassword) {
      setErrorMessage('Las contraseñas no coinciden');
    }else {
      setErrorMessage('');
    }
  } else {
    setErrorMessage('');
  }
};
